import { render, staticRenderFns } from "./SyllabusesListFilters.vue?vue&type=template&id=6583e7e8&scoped=true&"
import script from "./SyllabusesListFilters.vue?vue&type=script&lang=js&"
export * from "./SyllabusesListFilters.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusesListFilters.vue?vue&type=style&index=0&id=6583e7e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6583e7e8",
  null
  
)

export default component.exports